import styled, { keyframes } from 'styled-components';
import theme from '@/styles/theme';
import media from '@/styles/media';

export const ButtonDiv = styled.div`
  display: flex;
  align-items: center;  
  padding: 50px 50px 73px 50px;
  height: 160px;
  box-sizing: border-box;
  ${media.lg`
    justify-content: space-between;
    max-width: 420px;
    width: 100%;
    padding: 50px 10px;
  `}
`;

export const BasicButtonLabel = styled.label`
  margin-left: auto;
  padding-right: 20px;
  font-family: ${theme.fontFamily.regular};
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: right;
  color: #000000;
  ${media.lg`
    display: none;
  `}
`;

const spin = keyframes`
  from { transform: translate(-50%, -50%) rotate(0); }
  to { transform: translate(-50%, -50%) rotate(720deg); }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoadingSpinner = styled.div`
  position: relative;
  top: 9px;
  left: 9px;
  width: 13px;
  height: 13px;
  animation: 1.4s ease-in-out 0s infinite running ${spin};
  border-radius: 50%;
  border: 2px solid gray;
  border-bottom-color: transparent;
`;

export const BasicButton = styled.button`
  /* width: 100%; */
  cursor: pointer;
  padding: 12px 28px;
  background: ${theme.color.purple};
  border-radius: 8px;
  border: none;
  max-width: 420px;
  font-family:  ${theme.fontFamily.regular};
  font-size: 13px;
  line-height: 16px;
  color: #FFFFFF;
  &:hover {
    opacity: 0.9;
  }

  &:disabled{
    background-color: #4B586A;
  }
  &.singUp{
    ${media.xs`
      padding: 10px 30px;
    `}
  }
  &.login{
    ${media.lg`
      width: 100%;
    `}
  }
  &.signUpPage-login{
    ${media.lg`
      display: none;
    `}
  }
  &.password-reset{
    ${media.lg`
      display: none;
    `}
  }
  &.signup-reset{
    ${media.lg`
      display: none;
    `}
  }
  &.withdrawl {
    padding: 12px 39px;
  }
`;
